import { render, staticRenderFns } from "./ClientApprovals.vue?vue&type=template&id=439680c8"
import script from "./ClientApprovals.vue?vue&type=script&lang=js"
export * from "./ClientApprovals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports